import classNames from 'classnames'
import Link from 'components/link'

import { CHECKLIST, HOME, REGISTRY, GIFT_TRACKER } from 'registry/constants'

import {
  registryChecklistPath,
  registryHomePath,
  registryPath,
  giftTrackerPath,
} from 'lib/urls'

import { ACTIVE_NAV_SECTION_EVENT } from 'shared/constants'

import css from './BabyRegistryActions.scss'

interface BabyRegistryActionsProps {
  activeNav: string
  registryUrlSlug?: string
}

export const BabyRegistryActions = ({
  activeNav,
  registryUrlSlug,
}: BabyRegistryActionsProps) => (
  <ul className={css.navMenu}>
    <li>
      <Link
        className={classNames(
          css.navLink,
          activeNav == HOME ? css.active : null
        )}
        routerVersion={4}
        to={registryHomePath}
        onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, HOME)}
      >
        <div className={classNames(css.navIcon, css.iconHome)} />
        <span>Build Registry</span>
      </Link>
    </li>
    <li>
      <Link
        className={classNames(
          css.navLink,
          activeNav === REGISTRY ? css.active : null
        )}
        routerVersion={4}
        to={registryPath(registryUrlSlug)}
        onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, REGISTRY)}
      >
        <div className={classNames(css.navIcon, css.iconRegistry)} />
        <span>View Registry</span>
      </Link>
    </li>
    <li>
      <Link
        className={classNames(
          css.navLink,
          activeNav === CHECKLIST ? css.active : null
        )}
        routerVersion={4}
        to={registryChecklistPath}
        onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, CHECKLIST)}
      >
        <div className={classNames(css.navIcon, css.iconChecklist)} />
        <span>Checklist</span>
      </Link>
    </li>
    <li>
      <Link
        className={classNames(
          css.navLink,
          activeNav === GIFT_TRACKER ? css.active : null
        )}
        routerVersion={4}
        to={giftTrackerPath()}
        onClick={() => PubSub.publish(ACTIVE_NAV_SECTION_EVENT, null)}
      >
        <div className={classNames(css.navIcon, css.iconGiftTracker)} />
        <span>Gift Tracker</span>
      </Link>
    </li>
  </ul>
)
